import { render, staticRenderFns } from "./r-switch.vue?vue&type=template&id=5eec52b8"
import script from "./r-switch.vue?vue&type=script&lang=js"
export * from "./r-switch.vue?vue&type=script&lang=js"
import style0 from "./r-switch.vue?vue&type=style&index=0&id=5eec52b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports